import { useSidebar } from "../context/SidebarContext";
import { useNavigate } from "react-router-dom";
import useMobile from "../hooks/useMobile";
import { useUser } from "../context/UserContext";

const SearchHeader = () => {
  const { setSidebarOpen } = useSidebar();
  const navigate = useNavigate();
  // const [scrolled, setScrolled] = useState(false);
  const isMobile = useMobile();

  // useEffect(() => {
  //   const handleScroll = () => {
  //     setScrolled(window.scrollY > 20);
  //   };

  //   window.addEventListener("scroll", handleScroll);

  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);
  const { user } = useUser();

  return (
    // <div
    //   className={`header d-flex align-items-center justify-content-between gap-3 ${
    //     scrolled ? "header-scrolled" : ""
    //   }`}
    // >
    <div
      className={`header d-flex align-items-center justify-content-between gap-3`}
    >
      {/* Search */}
      <button
        className="btn hamburger-icon p-0"
        onClick={() => setSidebarOpen(true)}
      >
        <i className="fa-solid fa-bars"></i>
      </button>
      <span
        className="d-flex align-items-center gap-2 header-back-btn"
        onClick={() => navigate(-1)}
      >
        <i className="fa-solid fa-angle-left"></i>
        {`Back ${!isMobile ? "to Previous Page" : ""}`}
      </span>
      <div className="search-box">
        <input type="text" className="form-control" placeholder="Search" />
      </div>

      {/* Right Side */}
      <div className="d-flex align-items-center gap-3">
        <i className="fa-solid fa-bell"></i>

        <img src={`${process.env.REACT_APP_Url}/${user?.user.documentUrl}`} alt="user" className="user-img" />
      </div>
    </div>
  );
};

export default SearchHeader;
